import { Injectable } from '@angular/core';
import { Messaging, getToken, deleteToken } from '@angular/fire/messaging';
import { Subject } from 'rxjs';
import { saveFcmToken } from '../../state/actions/fcm.actions';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class FcmService {
  private backgroundMessageSubject = new Subject<any>();
  message$ = this.backgroundMessageSubject.asObservable();

  constructor(
    private msg: Messaging,
    private store: Store,
  ) {
  }

  async deleteToken() {
    await deleteToken(this.msg);
    this.store.dispatch(saveFcmToken({ token: '' }));
  }

  async initialize() {
    await this.requestPermission();

    const token = await this.getTokenRetry();

    if (token) {
      this.store.dispatch(saveFcmToken({ token }));
    }

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        this.backgroundMessageSubject.next(event.data);
      });
    }
  }

  async getTokenRetry(retry = 0): Promise<string> {
    try {
      const token = await getToken(this.msg, {});
      return token;
    } catch (error) {
      if (retry < 3) {
        return this.getTokenRetry(retry + 1);
      } else {
        console.error('Error getting FCM token', error);
        return '';
      }
    }
  }

  private async requestPermission() {
    const permission = await Notification.requestPermission();

    if (permission === 'granted') {
      console.log('Notification permission granted.');
    } else {
      console.log('Unable to get permission to notify.');
    }
  }
}